import {Injectable, inject} from '@angular/core';
import {LocalStorageService} from 'ngx-webstorage';
import {IQuickScanAnswerData} from '../../models/project/project-data';



@Injectable({providedIn: 'root'})
export class QuickscanDraftService {
    private static readonly KEY_PREFIX = 'quickscan-draft.';

    // localStorage, not sessionStorage: this draft must survive the browser tab
    // being closed (PRM-156/157), not just an in-app navigation.
    private localStorageService = inject(LocalStorageService);

    public save(projectId: number, answers: IQuickScanAnswerData[]): void {
        this.localStorageService.store(this.key(projectId), answers);
    }

    public load(projectId: number): IQuickScanAnswerData[] | null {
        const draft = this.localStorageService.retrieve(this.key(projectId));

        return this.isDraft(draft) ? draft : null;
    }

    public clear(projectId: number): void {
        this.localStorageService.clear(this.key(projectId));
    }

    private key(projectId: number): string {
        return `${QuickscanDraftService.KEY_PREFIX}${projectId}`;
    }

    private isDraft(value: unknown): value is IQuickScanAnswerData[] {
        return Array.isArray(value) && value.every((entry) =>
            !!entry
            && typeof entry === 'object'
            && typeof (entry as IQuickScanAnswerData).questionId === 'number'
        );
    }
}
